const MoonIcon = ({ fillColor }: { fillColor: string }) => (
  <svg width='22' height='22' viewBox='0 0 22 22' fill={fillColor} xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M19.9393 13.7518C18.8496 14.206 17.6805 14.4391 16.5 14.4375C11.5637 14.4375 7.5625 10.4363 7.5625 5.5C7.5625 4.28084 7.80633 3.11942 8.24817 2.06067C6.61968 2.74002 5.22864 3.88608 4.25024 5.35449C3.27184 6.8229 2.74985 8.54799 2.75 10.3125C2.75 15.2488 6.75125 19.25 11.6875 19.25C13.452 19.2502 15.1771 18.7282 16.6455 17.7498C18.1139 16.7714 19.26 15.3803 19.9393 13.7518Z'
      stroke='currentColor'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

export default MoonIcon;
